export default "__VITE_ASSET__cf367d69__"